/* Impression SCDM — LE SUPPORT RIGIDE, ET LES REGLES DE LA SIGNALISATION.

   ============================================================================
   1. LE SUPPORT N EST PAS UNE MATIERE
   ============================================================================
   La rangee « Materiau » decrit LE VINYLE : blanc mat, noir lustre,
   reflechissant. Un panneau d aluminium n est pas un vinyle — c est ce sur quoi
   on colle le vinyle. Les deux choix sont independants : on peut vouloir du
   reflechissant sur alupanel, du blanc mat sur coroplast, ou n importe quel
   vinyle sans support du tout.

   D ou une rangee a part, LA DERNIERE du configurateur (apres le laminage,
   juste avant le bouton « Ajouter a ma commande ») :

       Aucun          l autocollant seul, comme avant
       Alupanel 1/8   aluminium composite rigide, pour du permanent
       Coroplast 4 mm polypropylene cannele, leger, pour du temporaire

   Elle s affiche sur TOUT le catalogue, pas seulement sur la signalisation :
   un client qui fait dessiner sa propre pancarte doit pouvoir la recevoir
   montee, lui aussi.

   ============================================================================
   2. LE PRIX DE VENTE DU SUPPORT, ET RIEN D AUTRE
   ============================================================================
   Le support se debite dans une feuille de 4 x 8 pi, et le rendement de coupe
   change du tout au tout selon le format demande : un taux moyen au pied carre
   ferait perdre de l argent sur les grands panneaux et surfacturerait les
   petits. On compte donc les pieces pour de vrai, dans les deux orientations.

   CE CALCUL SE FAIT HORS LIGNE, PAS ICI. Ce fichier est servi au navigateur :
   tout ce qu il contient est lisible par n importe qui. Les prix d achat des
   feuilles, la majoration du proprietaire et le temps d atelier n y sont plus,
   parce qu ensemble ils donnaient la marge exacte a qui ouvrait le fichier.

   Il ne reste ici que des PRIX DE VENTE deja calcules — la table PRIX_VENTE,
   plus bas. Le dossier de reference des couts vit HORS DU THEME, dans la
   documentation du projet : c est la qu on refait le calcul quand un prix
   d achat bouge, et de la que sort la table.

   ============================================================================
   3. LE SUPPORT NE SE VEND QU EN GRANDEURS STANDARDS
   ============================================================================
   POSE LE 7 SEPTEMBRE 2026, a la demande du proprietaire : « je veux pas
   commencer a decouper des alupanel a 5 po pour des autocollants, je suis pret
   a rendre des format standard comme les autres font ».

   Avant, le support suivait n importe quelle grandeur. Un visuel de 5 x 5 po
   entamait une feuille de 4 x 8 pi dont le reste devenait une chute inutilisable.
   Le prix, lui, ne facturait que la surface reellement posee : la feuille
   perdue etait payee par l atelier.

   ENQUETE DU 7 SEPTEMBRE 2026 — 13 imprimeurs pour le coroplast, 9 pour l ACM,
   listes relevees sur les vraies pages de produit :

       18 x 24  offert par 11 des 13   le standard nord-americain
       24 x 36  offert par  9 des 13
       24 x 24  offert par  9 des 13
       12 x 18  offert par  8 des 13

   Et le marche ne met PAS la meme liste sur les deux supports : l aluminium
   composite se vend en petits formats de signalisation, le coroplast en formats
   de pancarte de pelouse. Affiche Expert, le concurrent quebecois direct, s en
   tient a quatre formats et l assume, prix affiches.

   LA REGLE RETENUE. Chaque support porte SA liste (champ « formats »). Le
   support n est offert que si le visuel est exactement a une de ces grandeurs.
   Sinon la pastille se ternit et une rangee de pastilles propose les grandeurs
   standards qui ont la PROPORTION du visuel : un clic et la piece s y met.

   POURQUOI PAR PROPORTION. Un visuel 3 x 4 mis de force dans un 24 x 36 (2 x 3)
   serait etire. On ne propose donc que les formats de meme proportion. Si aucune
   grandeur standard n a la proportion du visuel, le support n est pas offert et
   on le dit.

   ============================================================================
   3 bis. LES DEUX LISTES ONT ETE ELARGIES LE 10 SEPTEMBRE 2026
   ============================================================================
   CE QUI N ALLAIT PAS. Mesure faite dans le navigateur sur les 3 093 modeles
   en ligne : 2 042 d entre eux — les « panc- » — sont en 6 x 8 po, donc en
   PORTRAIT 3 x 4. A cette proportion, l ancienne liste ne donnait que quatre
   grandeurs sur l alupanel (6 x 8, 12 x 16, 18 x 24, 24 x 32) et UNE SEULE sur
   le coroplast (18 x 24). Cote carre, le plus grand panneau offert etait un
   24 x 24 : rien au-dessus.

   CE QU ON AJOUTE. Le Repertoire des dispositifs de signalisation routiere du
   Quebec donne ses panneaux en 300, 450, 600, 750, 900, 1200, 1800 et 2400 mm
   de cote (releve des 534 devis depouilles dans scdm-mtq-v2.js). On aligne
   l echelle des carres dessus, en pouces ronds :

       300 mm -> 12 x 12 po (305 mm)      750 mm -> 30 x 30 po (762 mm)
       450 mm -> 18 x 18 po (457 mm)      900 mm -> 36 x 36 po (914 mm)
       600 mm -> 24 x 24 po (610 mm)     1200 mm -> 48 x 48 po (1219 mm)

   ON NE DIT PAS QUE CES PANNEAUX SONT CONFORMES A QUOI QUE CE SOIT. Le
   ministere n homologue ni panneau, ni pellicule, ni aluminium, ni encre : ses
   programmes portent sur les poteaux, les extremites de glissiere et le
   marquage. On dit seulement que la DIMENSION correspond a celle du
   Repertoire. Meme regle que scdm-normes.js.

   LA LIMITE DE PRODUCTION. Largeur imprimable maximale 52 po, feuille rigide
   48 x 96 po : le PETIT cote d une piece ne peut pas depasser 48 po. Les
   panneaux de 1800 mm (70,9 po) et 2400 mm (94,5 po) ont leurs DEUX cotes
   au-dela de 52 po — pas realisables, pas offerts, la rangee dit « Trop grand ».

   LE 10 SEPTEMBRE, LES PRIX N AVAIENT PAS BOUGE D UN CENT en elargissant les
   deux listes : prixSupport() ne lit jamais une case de la table, il applique
   la DROITE que regleVente() deduit de ses deux extremes, et les grandeurs
   ajoutees ont donc ete chiffrees par la MEME formule que les anciennes, sans
   inventer un seul nombre.

   LA DROITE A ETE REFAITE LE 11 SEPTEMBRE 2026, DEUXIEME REVISION. Elle a
   de nouveau UNE PARTIE FIXE, et c est le changement important : couper,
   ebrecher et percer une plaque demande le meme geste qu elle fasse un pied
   carre ou six. Une droite qui passait par zero faisait donc payer la petite
   plaque trop peu et la grande trop cher. La droite vaut maintenant 3,00 $ la piece
   plus 8,00 $ le pied carre sur aluminium composite, et 2,75 $ la piece plus
   1,67 $ le pied carre sur plastique cannele. Voir la note au-dessus de
   PRIX_VENTE.

   TROIS FAMILLES ECHAPPENT A LA REGLE : la signalisation routiere (Repertoire
   du MTQ), les plaques de matieres dangereuses (250 mm par reglement) et les
   pictogrammes SIMDUT. Leur grandeur est IMPOSEE par une norme — on ne peut pas
   demander au client de la changer. Elles gardent le sur-mesure.

   LES DEUX LISTES se changent dans SUPPORTS, champ « formats », en pouces.
   Toutes les grandeurs retenues se debitent dans une feuille standard de
   48 x 96 po, certaines mieux que d autres. Le rendement de coupe n entre
   PAS dans le prix : le prix suit la droite de surface, et la chute est
   portee par l atelier — c est ce qui etait deja le cas pour le 24 x 36.
   Le detail du debit est dans la note d atelier du proprietaire.

   ============================================================================
   4. LES DEUX REGLES PROPRES A LA SIGNALISATION ROUTIERE
   ============================================================================
   A) AUCUN PRIX SUR LES PASTILLES DE MATIERE. « 0,06 $/po2 » a du sens pour un
      autocollant qu on vend au pouce carre ; sur un panneau de route, ca n en a
      pas — le client ne compose pas son prix, il achete un panneau. Les notes
      sont masquees en CSS, pas retirees : rien a defaire ailleurs.

   B) LE RABAIS DE QUANTITE NE PORTE QUE SUR CE QUI S AMORTIT VRAIMENT.
      La grille generale des autocollants descend jusqu a -68 % a cinquante
      exemplaires : c est juste pour une planche de collants qui sort d une
      seule mise en course, c est faux pour cinquante panneaux qu il faut
      couper, percer et monter un par un.

      Le proprietaire avait d abord tranche, le 5 septembre 2026 : aucun rabais
      du tout, cinquante panneaux coutent cinquante fois un panneau. Le
      6 septembre, apres l audit de vingt fournisseurs quebecois, canadiens et
      americains, la regle est devenue plus juste sans devenir risquee :

          LA MISE EN ROUTE SE PAIE UNE SEULE FOIS. Le reste ne bouge pas.

      On fait le fichier, l epreuve et le calage machine UNE fois, qu il y ait
      un panneau ou cent. Facturer la mise en route cent fois pour un travail
      fait une fois, c est ce qui rendait le prix injuste a la grande quantite.
      Le montant de cette mise en route est MEC, plus bas : 26 $ depuis le
      11 septembre 2026, 18 $ avant.

      EN REVANCHE, RIEN D AUTRE NE BAISSE. La matiere — le film reflechissant
      et la feuille de support — ne baisse jamais : le centieme panneau
      consomme exactement autant que le premier. Le faconnage non plus :
      couper, percer et emballer une piece prend le meme temps la centieme
      fois. C est la garantie que le rabais de quantite ne mord jamais sur
      ce qui ne baisse pas.

      OU EST LE MARCHE : Uline Canada -12,9 %, Affichage SST -12,8 % sur
      alupanel, SmartSign -10 % sur du reflechissant. Signoplus et Alpha Signa,
      les deux fabricants quebecois, n affichent aucune grille de quantite. On
      se place donc au niveau du meilleur du marche canadien, sans aller dans
      l agressivite americaine.

      COMMENT. On ne touche pas a scdm.js. Il calcule
      « total = base(q) + supplements », ou base(q) est degressif. On calcule
      donc le prix d UN panneau, on le multiplie par q, on retire la mise en
      route des (q - 1) panneaux suivants, et on ecrit dans le supplement de la
      matiere exactement ce qu il faut pour retomber dessus.

   ============================================================================
   5. COMMENT LE PRIX ENTRE DANS LE CONFIGURATEUR
   ============================================================================
   scdm.js calcule le supplement d une matiere avec « parPo2 x surface x
   quantite ». C est le seul levier qu on ait de l exterieur. On y ecrit donc la
   somme de tout ce qu on veut ajouter, divisee par (surface x quantite) — la
   multiplication de scdm.js redonne le montant exact. Un montant fixe par piece
   (la part fixe du prix du support) s ecrit « montant / surface » : ca marche a
   n importe quelle grandeur.

   On garde une copie intacte de la table des matieres au demarrage, et on la
   remet en place AVANT chaque recalcul. Le supplement propre de la matiere
   (les +12 % du noir lustre, les 0,06 $/po2 du reflechissant) est recalcule a
   partir de cette copie et rajoute : il n est jamais perdu.

   OU IL VIT. C etait un fichier de Contenu > Fichiers. Depuis le 6 septembre
   2026 c est un ASSET DU THEME : l API du theme sait le lire et le reecrire,
   donc on peut le corriger et VERIFIER le resultat sans passer par le
   navigateur. L ancienne copie dans Contenu > Fichiers ne sert plus a rien.

   ATTENTION : sans ce fichier, la rangee « Support » disparait et la
   signalisation routiere retrouve les rabais de quantite de la grille
   generale — ceux des autocollants, qui n ont rien a faire sur un panneau.

   Charge depuis snippets/scdm-minimum.liquid, en defer, apres scdm-normes.js. */

(function () {
  'use strict';

  /* ------------------------------------------------------------- reglages */

  /* Surface utile d une feuille de 4 x 8 pi. On prend la cote NOMINALE et non
     une cote reduite : sur une scie a panneau, deux pieces de 24 po sortent
     d une feuille de 48 po, la lame se prenant dans le millimetre de jeu. Une
     marge de 1/4 po aurait fait tomber le 24 x 24 de huit pieces a trois par
     feuille, et son prix aurait double d un coup — un decrochage que le metier
     ne connait pas (Alphasigna vend le 24 x 24 sans surprime). */
  var UTILE_L = 48;           /* po */
  var UTILE_H = 96;           /* po */

  /* LARGEUR IMPRIMABLE MAXIMALE. Une piece dont le PETIT cote depasse cette
     valeur ne peut pas etre imprimee, quelle que soit la feuille : on ne
     l offre pas, on dit « Trop grand ». Aujourd hui la feuille rigide (48 po)
     est plus contraignante que la presse, donc cette borne ne retranche rien ;
     elle est ecrite pour que la vraie limite reste vraie si la feuille change. */
  var IMPRIMABLE = 52;        /* po */

  var DELAI = '10 jours ouvrables';

  /* Les supports. Ils ne portent PLUS AUCUN chiffre d argent : ni prix
     d achat, ni majoration, ni temps d atelier. Ce que le client paie sort de
     la table PRIX_VENTE, juste en dessous, et cette table est deja un prix de
     vente. Positionnement de marche : audit du 5 septembre 2026,
     claude/audit-prix-marche-quebec-2026.md. */
  var SUPPORTS = [
    { id: 'aucun', label: 'Aucun', sous: 'Autocollant seul' },
    { id: 'alupanel', label: 'Alupanel® 1/8 po', sous: 'Aluminium composite',
      /* LA LISTE, RANGEE PAR PROPORTION — c est la proportion qui decide de ce
         que le client voit, pas la taille. Quatre echelles completes, de la
         plus petite piece qu on sait couper au plus grand panneau qui entre
         dans une feuille de 48 x 96.

         Carres 1:1   : l echelle du Repertoire de signalisation routiere.
                        12, 18, 24, 30, 36 et 48 po sont les equivalents en
                        pouces ronds de 300, 450, 600, 750, 900 et 1200 mm.
         Portrait 3:4 : la proportion des 2 042 pancartes du catalogue, qui
                        sont toutes en 6 x 8 po. C est l echelle qui manquait.
         2:3          : la proportion des drapeaux et du 24 x 36 historique.
         1:2          : les panonceaux. 24 x 12, 30 x 15, 36 x 18 et 48 x 24
                        po repondent aux 600 x 300, 750 x 375, 900 x 450 et
                        1200 x 600 mm du Repertoire.

         Un format tourne tout seul dans le sens du visuel (voir orienter) :
         [6, 8] sert aussi bien le 6 x 8 portrait que le 8 x 6 paysage. */
      formats: [[6, 6], [8, 8], [12, 12], [18, 18], [24, 24], [30, 30], [36, 36], [48, 48],
                [6, 8], [9, 12], [12, 16], [15, 20], [18, 24], [24, 32], [30, 40], [36, 48],
                [8, 12], [12, 18], [16, 24], [24, 36], [32, 48],
                [6, 12], [12, 24], [15, 30], [18, 36], [24, 48]],
      texte: 'Panneau rigide d’aluminium composite de 1/8 po (3 mm), coupé à votre ' +
             'grandeur, ébréché et percé pour la pose. C’est le support de la ' +
             'signalisation permanente : il ne rouille pas, il ne gauchit pas.' },
    { id: 'coroplast', label: 'Coroplast® 4 mm', sous: 'Polypropylène cannelé',
      /* MEME ECHELLE QUE L ALUPANEL, plus les bandeaux. Le coroplast avait la
         liste la plus courte des deux, et c est lui qui en souffrait le plus :
         a la proportion 3 x 4 des pancartes du catalogue, il n offrait QUE le
         18 x 24. Il se coupe dans la meme feuille de 48 x 96 que l aluminium
         composite et se vend deja en 4 x 8 pi chez les fournisseurs : rien ne
         justifiait de lui refuser les memes grandeurs.

         Le 18 x 24 reste le standard nord-americain (11 imprimeurs sur 13) et
         le 24 x 36 le grand format de l immobilier et du chantier ; ils sont
         toujours la, au meme prix.

         Bandeaux 1:4 : le 6 x 24 qu on ajoute sous une pancarte, et son grand
         frere le 12 x 48. Ils restent propres au coroplast — c est un usage de
         pancarte de pelouse, pas de signalisation permanente. */
      formats: [[6, 6], [8, 8], [12, 12], [18, 18], [24, 24], [30, 30], [36, 36], [48, 48],
                [6, 8], [9, 12], [12, 16], [15, 20], [18, 24], [24, 32], [30, 40], [36, 48],
                [8, 12], [12, 18], [16, 24], [24, 36], [32, 48],
                [6, 12], [12, 24], [15, 30], [18, 36], [24, 48],
                [6, 24], [12, 48]],
      texte: 'Panneau léger de polypropylène cannelé de 4 mm, coupé à votre ' +
             'grandeur. C’est le support des pancartes de chantier, d’élection ' +
             'et d’immobilier : il ne casse pas au gel et il coûte trois fois moins ' +
             'cher qu’un panneau d’aluminium.' }
  ];

  /* PRIX DE VENTE DES SUPPORTS RIGIDES — table calculee HORS LIGNE.

     Cette table est le RESULTAT d un calcul fait hors ligne. Elle ne contient
     que des prix de vente, deja majores, deja arrondis a rien : ce que le
     client paie pour la piece montee, par exemplaire, avant la quantite.

     LES COUTS REELS NE DOIVENT JAMAIS REVENIR DANS CE FICHIER. Prix d achat
     des feuilles, majoration du proprietaire, temps d atelier, rendement de
     coupe : rien de tout cela n a sa place ici. Ce fichier est servi au
     navigateur, donc tout ce qu il contient est lisible par n importe qui, et
     la structure de cout se reconstituerait en trois lignes.

     LE FICHIER DE REFERENCE DES COUTS VIT HORS DU THEME, dans la
     documentation du projet. C est la qu on refait le calcul quand un prix
     d achat bouge ; on ne recopie ici que le prix de vente qui en sort.

     Cle : « petit cote x grand cote » en pouces. Les decimales longues sont
     voulues — elles reprennent au bit pres le prix qui etait affiche avant,
     pour que rien ne bouge d un cent sur les commandes en cours.

     CETTE TABLE N A PAS ETE TOUCHEE LE 10 SEPTEMBRE 2026, ET C EST VOULU. Les
     grandeurs ajoutees ce jour-la n y figurent pas et n ont pas a y figurer :
     prixSupport() ne cherche jamais une case par son nom, il demande a
     regleVente() la droite que ces dix-sept lignes decrivent, et applique la
     droite. Ajouter des lignes ici aurait deplace les deux extremes dont la
     droite est deduite — donc, au dernier bit pres, la droite elle-meme, donc
     un prix existant. On laisse la table exactement comme elle etait ; les
     nouvelles grandeurs sont chiffrees par la meme droite que les anciennes. */
  /* ---------------------------------------------------------------------
     LES DEUX DROITES REFAITES — 11 septembre 2026, deuxieme passe.

     CE BLOC A ETE VIDE DE SES MONTANTS LE 11 SEPTEMBRE 2026, ET C EST
     IMPORTANT. Il portait des chiffres d approvisionnement et la regle de
     vente qui s applique par-dessus. Ce fichier part au navigateur : tout le
     monde peut le lire, concurrents compris, et ces nombres ensemble
     donnaient la structure de cout de l atelier a qui ouvrait le fichier.
     NE LES REECRIVEZ PAS ICI. Ils vivent dans la note
     d atelier du proprietaire, hors du site, avec les factures.

     CE QUI A CHANGE, ET POURQUOI — sans les montants. Les deux droites
     passaient par zero : le prix du panneau nu etait purement proportionnel a
     la surface. C etait faux. Couper une plaque, l ebrecher et la percer
     demande le meme geste qu elle fasse un pied carre ou six, et ce geste ne
     disparait pas sur une petite plaque. Une droite qui passe par zero fait
     donc payer la petite plaque trop peu et la grande trop cher.

     Les deux droites reprennent donc une PARTIE FIXE PAR PIECE, et leur pente
     vient de la table de supports, tenue a part. L aluminium composite reste
     nettement plus cher a l achat que le plastique cannele pour le client, et
     l ecart entre les deux droites le dit.

     LES DEUX LIGNES QUI COMPTENT, ET POURQUOI TOUTES LES AUTRES BOUGENT
     AUSSI. regleVente() ne lit que DEUX cases par support : la plus petite
     surface et la plus grande. Ce sont elles, et elles seules, qui donnent
     la droite. On recalcule quand meme TOUTES les cases sur la nouvelle
     droite : une table dont les cases intermediaires ne sont plus sur la
     droite qu elle sert a deduire est une table qui ment au prochain qui
     l ouvrira. Chaque case vaut exactement surface x pente.

     Verification des deux droites, telles que regleVente() les deduit des
     deux cases extremes de chaque support :
         alupanel  pente (51 - 5)/(864 - 36)      = 0,0555…  $/po2 = 8,00 $/pi2
                   fixe  5 - 0,0555… x 36         = 3,00 $ la piece
         coroplast pente (12.77 - 4.42)/(864 - 144) = 0,0116  $/po2 = 1,67 $/pi2
                   fixe  4,42 - 0,0116 x 144      = 2,75 $ la piece

     ATTENTION AU 6 x 24 DU COROPLAST. Il fait 144 po2, exactement comme le
     12 x 12, et il est ECRIT EN PREMIER : c est donc LUI que regleVente()
     retient comme point bas, pas le 12 x 12. Changer le 12 x 12 tout seul
     n aurait rien change au prix. Les deux doivent rester egaux.
     --------------------------------------------------------------------- */
  var PRIX_VENTE = {
    alupanel: {
      '6x6': 5,
      '6x8': 5.667,
      '8x12': 8.333,
      '12x12': 11,
      '12x16': 13.667,
      '12x18': 15,
      '18x24': 27,
      '24x24': 35,
      '24x32': 45.667,
      '24x36': 51
    },
    coroplast: {
      '6x24': 4.42,
      '12x12': 4.42,
      '12x18': 5.255,
      '12x24': 6.09,
      '18x24': 7.76,
      '24x24': 9.43,
      '24x36': 12.77
    }
  };

  /* ---------------------------------------------------------------------
     LA GRILLE DES PANCARTES

     Le probleme, decouvert a l audit du 5 septembre 2026 : la grille de
     scdm-data.js a ete calee sur des imprimeurs d AUTOCOLLANTS (StickerApp,
     Sticker Mule), ou un « 1 exemplaire » n existe presque pas. Decomposee
     comme le marche la construit — un fixe par commande plus un taux a la
     surface — elle donne 39 $ de mise en course et 13 $/pi2. Le taux est
     juste ; les 39 $ sont quatre fois le marche (Alphasigna : 8,25 $).
     C est ce qui faisait qu une pancarte de 12 x 12 coutait 52 $ chez nous
     contre 19,25 $ chez eux.

     On ne peut pas corriger ca dans scdm-data.js : les memes lignes servent
     les autocollants, ou le prix au volume etait bien cale. Les deux produits
     ont besoin de deux grilles.

     LA SOLUTION. scdm.js lit la grille a CHAQUE calcul, dans l objet vivant
     window.SCDM_DATA.GRILLE. On garde donc une copie de la grille des
     autocollants au demarrage, on fabrique celle des pancartes, et on ecrit
     l une ou l autre dans l objet juste avant chaque calcul. Aucune
     modification de scdm.js.

     LE MODELE : MEC de mise en course + surface x quantite x taux(q), ou MEC
     et le tableau TAUX sont les deux seuls reglages, juste en dessous.
     Le taux ne paie QUE L IMPRESSION : le panneau nu est facture a part par
     la droite PRIX_VENTE, plus haut. Voir la note sur TAUX, juste en dessous,
     pour les nombres et pour la raison de chacun.

     Verifie sur les dix-huit lignes de la grille : le prix monte toujours
     avec la taille, monte toujours avec la quantite, et le prix unitaire ne
     remonte jamais. */
  /* DEUXIEME PASSE — 11 septembre 2026.

     TROISIEME PASSE — 11 septembre 2026, en fin de journee.

     CE QUI CHANGE, ET POURQUOI. La passe du matin avait ete batie sur des
     hypotheses que le proprietaire a depuis remplacees par la mesure tenue
     dans sa note d atelier, hors du site. Les deux reglages remontent.

     1. LE TAUX NE PAIE QUE L IMPRESSION — ca, ca ne change pas. Le panneau
        nu est facture a part par la droite PRIX_VENTE, juste au-dessus. Mais
        le taux etait descendu trop bas : il ne portait plus le temps de
        pose, qui est le poste le plus lourd d une pancarte et qui ne baisse
        pas avec la quantite. Il part maintenant de 2,40 $/pi2 et descend a
        1,44 $/pi2 au lieu de 1,20 $.

     2. LA MISE EN COURSE PASSE DE 26 $ A 30 $. C est le seul endroit ou vit
        le travail fait UNE FOIS par commande : l amorce de media perdue a
        chaque chargement, le calage, la preparation du fichier et le tirage
        d essai. Elle est facturee une seule fois, qu il y ait une piece ou
        mille — et c est precisement ce qui permet au taux au pied carre de
        descendre aussi bas juste en dessous. Ne la repartissez JAMAIS sur les
        exemplaires : ce serait refacturer mille fois une perte survenue une
        fois.

     CE QUE CA DONNE SUR LE MARCHE, ET IL FAUT LE SAVOIR. Sur le plastique
     cannele, nos prix passent AU-DESSUS de tout ce qui est affiche au Canada
     des dix exemplaires. Ce n est pas un mauvais reglage : les imprimeurs qui
     affichent 5 a 10 $ la pancarte impriment DIRECTEMENT sur le panneau. Ici
     on imprime un vinyle et on le pose — c est un autre produit, plus long a
     faire. S aligner sur ces prix-la reviendrait a vendre un autre produit
     que le notre. Le detail est dans la note d atelier du proprietaire,
     hors du site.

     Verifie a la main sur les dix paliers : taux(q) descend toujours,
     q x taux(q) monte toujours — donc le prix total monte avec la quantite
     et le prix unitaire ne remonte jamais. Et taux(1) reste le plus haut de
     la table, ce dont la branche « routier » d appliquer() a besoin pour que
     son « voulu » ne devienne jamais negatif.
     La lecture entre deux paliers reste LOGARITHMIQUE (voir tauxQte). */
  var MEC = 30;
  var TAUX = [[1, 2.40], [5, 2.15], [10, 1.95], [25, 1.78],
             [50, 1.70], [100, 1.62], [250, 1.55], [500, 1.50],
             [1000, 1.47], [2000, 1.44]];

  function tauxQte(q) {
    if (q <= TAUX[0][0]) return TAUX[0][1];
    if (q >= TAUX[TAUX.length - 1][0]) return TAUX[TAUX.length - 1][1];
    for (var i = 0; i < TAUX.length - 1; i++) {
      var q0 = TAUX[i][0], t0 = TAUX[i][1], q1 = TAUX[i + 1][0], t1 = TAUX[i + 1][1];
      if (q0 <= q && q <= q1) {
        var f = (Math.log(q) - Math.log(q0)) / (Math.log(q1) - Math.log(q0));
        return t0 + (t1 - t0) * f;
      }
    }
    return TAUX[0][1];
  }

  function prixPancarte(cote, q) {
    return Math.round(MEC + (cote * cote / 144) * q * tauxQte(q));
  }

  var GRILLE_COLLANT = null;   /* la grille d origine, celle des autocollants */
  var GRILLE_PANCARTE = null;  /* celle qu on fabrique */
  var grilleActive = 'collant';

  function memoriserGrille() {
    if (GRILLE_COLLANT) return;
    var d = D();
    if (!d || !d.GRILLE) return;
    GRILLE_COLLANT = {}; GRILLE_PANCARTE = {};
    Object.keys(d.GRILLE).forEach(function (cote) {
      GRILLE_COLLANT[cote] = {};
      GRILLE_PANCARTE[cote] = {};
      Object.keys(d.GRILLE[cote]).forEach(function (q) {
        GRILLE_COLLANT[cote][q] = d.GRILLE[cote][q];
        GRILLE_PANCARTE[cote][q] = prixPancarte(Number(cote), Number(q));
      });
    });
  }

  /* scdm.js a capture l OBJET grille au chargement : on ecrit dedans, cle par
     cle. Le remplacer d un bloc ne changerait rien pour lui. */
  function poserGrille(nom) {
    var d = D();
    if (!GRILLE_COLLANT || !d || grilleActive === nom) return;
    var src = (nom === 'pancarte') ? GRILLE_PANCARTE : GRILLE_COLLANT;
    Object.keys(src).forEach(function (cote) {
      Object.keys(src[cote]).forEach(function (q) { d.GRILLE[cote][q] = src[cote][q]; });
    });
    grilleActive = nom;
  }

  /* ---------------------------------------------------------------- l etat */

  var choix = 'aucun';        /* le support VOULU par le client */
  var effectif = null;        /* celui qu on applique vraiment */
  var ORIG = null;            /* copie intacte de la table des matieres */
  var boite = null;           /* l encadre de la signalisation routiere */
  var champ = null;           /* la rangee des supports */
  var note = null;            /* le texte sous la rangee */
  var dernierRendu = '';

  function S() { return window.SCDM; }
  function D() { return window.SCDM_DATA; }

  function texteSupport(cle, repli, params) {
    var source = document.getElementById('scdmSupportI18n');
    var texte = source && source.getAttribute('data-' + cle);
    return (texte || repli).replace(/\{([a-z_]+)\}/g, function(mot, nom) {
      return params && Object.prototype.hasOwnProperty.call(params, nom) ? String(params[nom]) : mot;
    });
  }

  function proportionSupport(c) {
    return proportion(c).replace('carré', texteSupport('square', 'carré'))
      .replace('paysage', texteSupport('landscape', 'paysage'))
      .replace('portrait', texteSupport('portrait', 'portrait'));
  }

  /* ------------------------------------------------------------------ style */

  function style() {
    if (document.getElementById('scdmPanneauStyle')) return;
    var s = document.createElement('style');
    s.id = 'scdmPanneauStyle';
    s.textContent = [
      /* L encadre de la signalisation routiere */
      '.scdm-panneau{margin:0 0 10px;padding:11px 13px;border-radius:10px;',
      'border:1px solid #33507A;background:#131C29;color:#C6D4E6;',
      'font-size:12.5px;line-height:1.5}',
      '.scdm-panneau[hidden]{display:none !important}',
      '.scdm-panneau .pn-t{display:block;margin:0 0 4px;font-size:13px;font-weight:600;color:#8FB6E8}',
      '.scdm-panneau p{margin:0 0 6px}',
      '.scdm-panneau p:last-child{margin:0}',
      '.scdm-panneau .pn-d{color:#EBD9A8}',
      '.scdm-panneau b{color:#EDF1F7}',
      'html.scdm-jour .scdm-panneau{background:#EEF4FD;border-color:#A9C2E4;color:#26364C}',
      'html.scdm-jour .scdm-panneau .pn-t{color:#14427E}',
      'html.scdm-jour .scdm-panneau .pn-d{color:#7A5510}',
      'html.scdm-jour .scdm-panneau b{color:#12203A}',

      /* Le texte sous la rangee des supports */
      '.scdm-sup-note{margin:8px 0 0;font-size:12.5px;line-height:1.5;color:#98A1B2}',
      '.scdm-sup-note b{color:#EDF1F7}',
      'html.scdm-jour .scdm-sup-note{color:#5A6678}',
      'html.scdm-jour .scdm-sup-note b{color:#12203A}',
      '#scdmSupports .opt[aria-disabled="true"]{opacity:.45;cursor:not-allowed}',
      '#scdmSupports .opt.hors{opacity:.6}',

      /* La rangee des grandeurs standards */
      '.scdm-fmt{margin:9px 0 0}',
      '.scdm-fmt[hidden]{display:none !important}',
      '.scdm-fmt .t{display:block;margin:0 0 6px;font-size:12.5px;color:#98A1B2}',
      '.scdm-fmt .t b{color:#EDF1F7}',
      '.scdm-fmt .g{display:flex;flex-wrap:wrap;gap:6px}',
      '.scdm-fmt button{padding:5px 11px 6px;border-radius:8px;cursor:pointer;',
      'border:1px solid #33507A;background:#131C29;color:#C6D4E6;font-size:12.5px;',
      'line-height:1.25;text-align:center}',
      /* Les millimetres sous les pouces : deuxieme ligne, plus petite, pour que
         la pastille reste lisible d un coup d oeil en pouces. */
      '.scdm-fmt button small{display:block;font-size:10.5px;opacity:.72;',
      'letter-spacing:.01em}',
      '.scdm-fmt button:hover{border-color:#5C82BE}',
      '.scdm-fmt button.on{border-color:#F26A21;color:#EDF1F7;font-weight:600}',
      '.scdm-fmt .vide{margin:0;font-size:12.5px;line-height:1.5;color:#98A1B2}',
      '.scdm-fmt .vide b{color:#EDF1F7}',
      'html.scdm-jour .scdm-fmt .t,html.scdm-jour .scdm-fmt .vide{color:#5A6678}',
      'html.scdm-jour .scdm-fmt .t b,html.scdm-jour .scdm-fmt .vide b{color:#12203A}',
      'html.scdm-jour .scdm-fmt button{background:#EEF4FD;border-color:#A9C2E4;color:#26364C}',
      'html.scdm-jour .scdm-fmt button.on{border-color:#F26A21;color:#12203A}',

      /* SIGNALISATION ROUTIERE : pas de prix sur les pastilles de matiere, et
         pas de badge de rabais sur les quantites.

         POURQUOI LES BADGES RESTENT CACHES ALORS QU IL Y A MAINTENANT UN VRAI
         RABAIS : scdm.js calcule le pourcentage affiche a partir de la grille
         generale, qui descend beaucoup plus bas que notre rabais reel. Il
         annoncerait -40 % la ou le client en obtient -12. Un chiffre faux est
         pire que pas de chiffre : on laisse les badges caches et on explique
         la regle en toutes lettres juste en dessous (voir #scdmQteMot).

         En CSS et pas en JavaScript, parce que scdm.js reconstruit ces deux
         rangees a chaque redessin : une retouche du DOM serait effacee a la
         premiere frappe du client. */
      'body.scdm-routier #scdmMatieres small{display:none !important}',
      'body.scdm-routier #scdmQtes .save,',
      'body.scdm-routier #scdmQtes .u{visibility:hidden !important}',

      /* La phrase qui remplace les badges de rabais. Elle vit HORS de
         #scdmQtes, que scdm.js reconstruit a chaque redessin. */
      '.scdm-qte-mot{margin:8px 0 0;font-size:12.5px;line-height:1.5;color:#98A1B2}',
      '.scdm-qte-mot[hidden]{display:none !important}',
      'html.scdm-jour .scdm-qte-mot{color:#5A6678}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------------- les outils */

  function nb(v, d) { return v.toFixed(d === undefined ? 2 : d).replace('.', ','); }

  /* POUCES ET MILLIMETRES, TOUJOURS LES DEUX. Regle du site : partout ou une
     dimension est affichee, les deux unites doivent apparaitre. Le client de
     pancarte pense en pouces, celui qui a un devis de signalisation routiere
     pense en millimetres, et c est souvent la meme personne. */
  function mmDe(po) { return Math.round(po * 25.4); }

  function enPo(l, h) { return nb(l, 0) + ' × ' + nb(h, 0) + ' po'; }

  function enMm(l, h) { return mmDe(l) + ' × ' + mmDe(h) + ' mm'; }

  /* LA PROPORTION DU VISUEL, DITE EN MOTS. On cherche la plus petite fraction
     p/q (q jusqu a 12) qui tombe dans la meme tolerance que memeProportion :
     un 6 x 8 devient « 3 × 4 portrait », un 4 x 2,67 devient « 2 × 3 paysage ».
     Si rien ne tombe juste, on redonne simplement les cotes. */
  function proportion(c) {
    var p = Math.min(c.l, c.h), g = Math.max(c.l, c.h), r = p / g;
    if (Math.abs(r - 1) <= TOL_RATIO) return 'carré';
    for (var q = 2; q <= 12; q++) {
      var n = Math.round(r * q);
      if (n < 1 || n >= q) continue;
      if (Math.abs(n / q - r) <= TOL_RATIO * r) {
        return n + ' × ' + q + (c.l >= c.h ? ' paysage' : ' portrait');
      }
    }
    return nb(p, 1) + ' × ' + nb(g, 1) + (c.l >= c.h ? ' paysage' : ' portrait');
  }

  function support(id) {
    var v = id || choix;
    for (var i = 0; i < SUPPORTS.length; i++) if (SUPPORTS[i].id === v) return SUPPORTS[i];
    return SUPPORTS[0];
  }

  /* Le modele charge, s il vient de la bibliotheque. scdm-modeles.js depose
     « modele-scdm-<id>.<ext> » dans le configurateur. */
  function modeleCharge() {
    var e = S() && S().etat;
    var nom = (e && e.fichier && e.fichier.name) || '';
    var m = nom.match(/^modele-scdm-(.+)\.[A-Za-z0-9]+$/);
    return m ? m[1] : null;
  }

  function estRoutier() {
    var id = modeleCharge();
    return !!(id && id.indexOf('mtq-') === 0);
  }

  /* Les cotes en POUCES. scdm.js garde toujours etat.larg / etat.haut en
     pouces — le choix mm/cm ne change que l affichage. */
  function cotes() {
    var e = S() && S().etat;
    if (!e || !S().calcul) return null;
    var c = S().calcul();
    var a = c ? c.aire : 0;
    if (!(a > 0)) return null;
    var l = Number(e.larg) || 0, h = Number(e.haut) || 0;
    if (!(l > 0 && h > 0) || Math.abs(l * h - a) > 0.5) l = h = Math.sqrt(a);
    return { l: l, h: h, aire: l * h };
  }

  function qte() {
    var d = D(), e = S() && S().etat;
    var q = Number(e && e.qte) || 1;
    return Math.max(d.QTE_MIN || 1, Math.min(d.QTE_MAX || 10000, q));
  }

  function parFeuille(l, h) {
    var a = Math.floor(UTILE_L / l) * Math.floor(UTILE_H / h);
    var b = Math.floor(UTILE_L / h) * Math.floor(UTILE_H / l);
    return Math.max(a, b);
  }

  /* ------------------------------------------------- les grandeurs standards */

  var TOL_RATIO = 0.02;   /* 2 % : un 18 x 24 et un 18,3 x 24 sont le meme panneau */
  var TOL_COTE = 0.15;    /* po : la tolerance sur le cote lui-meme */

  /* Les modeles dont la grandeur est IMPOSEE par une norme. On ne peut pas
     demander au client de changer une dimension qu un reglement lui dicte :
     ceux-la gardent le sur-mesure, et l atelier coupe a la demande. */
  function dimensionImposee() {
    var id = modeleCharge();
    if (!id) return false;
    return id.indexOf('mtq-') === 0 || id.indexOf('tmd-') === 0 ||
           id.indexOf('simdut-') === 0;
  }

  function memeProportion(f, c) {
    var rf = Math.min(f[0], f[1]) / Math.max(f[0], f[1]);
    var rc = Math.min(c.l, c.h) / Math.max(c.l, c.h);
    return Math.abs(rf - rc) <= TOL_RATIO * rf;
  }

  /* Le format standard tourne dans le sens du visuel : un 18 x 24 devient un
     24 x 18 devant une image couchee. */
  function orienter(f, c) {
    var p = Math.min(f[0], f[1]), g = Math.max(f[0], f[1]);
    return (c.l >= c.h) ? { l: g, h: p } : { l: p, h: g };
  }

  /* Les grandeurs standards de ce support qui ont la proportion du visuel,
     de la plus petite a la plus grande. */
  function formatsPour(s, c) {
    if (!s || !s.formats || !c) return [];
    var out = [];
    s.formats.forEach(function (f) {
      if (memeProportion(f, c)) out.push(orienter(f, c));
    });
    out.sort(function (a, b) { return a.l * a.h - b.l * b.h; });
    return out;
  }

  /* La grandeur standard a laquelle le visuel se trouve DEJA, ou null. */
  function estStandard(s, c) {
    var liste = formatsPour(s, c);
    for (var i = 0; i < liste.length; i++) {
      if (Math.abs(liste[i].l - c.l) <= TOL_COTE &&
          Math.abs(liste[i].h - c.h) <= TOL_COTE) return liste[i];
    }
    return null;
  }

  /* Trois raisons de ne pas offrir un support : il ne rentre pas dans une
     feuille, la grandeur n est pas standard, ou la proportion ne correspond a
     aucun format. La dimension imposee par une norme passe outre. */
  window.SCDM_SUPPORT_DEMANDE = function () {
    var s = support(), c = cotes();
    return { id: s.id, label: s.label, routier: estRoutier(),
      surMesure: !!(c && s.id !== 'aucun' && !dimensionImposee() && !estStandard(s, c)) };
  };

  function supportOffert(s, c) {
    if (!s || s.id === 'aucun' || !c) return true;
    if (Math.min(c.l, c.h) > IMPRIMABLE) return false;
    if (parFeuille(c.l, c.h) < 1) return false;
    if (dimensionImposee()) return true;
    return !!estStandard(s, c);
  }

  /* Poser une grandeur standard sur le configurateur. etat.larg et etat.haut
     sont toujours en pouces, mais les CHAMPS sont dans l unite affichee : on
     convertit avant d ecrire. On passe par un evenement « input » pour que ce
     soit l ecouteur de scdm.js qui redessine, comme si le client avait tape. */
  function poserFormat(f) {
    var e = S() && S().etat;
    if (!e || !f) return;
    var u = e.unite || 'po';
    var k = (u === 'mm') ? 25.4 : (u === 'cm' ? 2.54 : 1);
    var arrondi = function (v) { return Math.round(v * k * 100) / 100; };

    var sel = document.getElementById('scdmTaille');
    if (sel && sel.value !== 'custom') {
      sel.value = 'custom';
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var L = document.getElementById('scdmLargeur');
    var H = document.getElementById('scdmHauteur');
    if (L) { L.value = arrondi(f.l); L.dispatchEvent(new Event('input', { bubbles: true })); }
    if (H) { H.value = arrondi(f.h); H.dispatchEvent(new Event('input', { bubbles: true })); }
  }

  /* La droite de prix de vente d un support, DEDUITE de sa table PRIX_VENTE :
     prix = fixe + pente x surface. Elle sert aux TROIS familles a grandeur
     imposee par une norme (MTQ, TMD, SIMDUT), les seules qui gardent le
     sur-mesure : leur grandeur n est dans aucune table.

     On la deduit au lieu de l ecrire, pour que la table reste la seule source
     du prix — et parce que deux lignes de la table suffisent de toute facon a
     la retrouver : la deduire n expose donc rien de plus que la table. */
  var REGLE_VENTE = {};

  function regleVente(id) {
    if (REGLE_VENTE[id] !== undefined) return REGLE_VENTE[id];
    var t = PRIX_VENTE[id], r = null;
    if (t) {
      var bas = null, haut = null;
      Object.keys(t).forEach(function (k) {
        var d = k.split('x');
        var a = Number(d[0]) * Number(d[1]);
        var p = { aire: a, prix: t[k] };
        if (!bas || a < bas.aire) bas = p;
        if (!haut || a > haut.aire) haut = p;
      });
      if (bas && haut && haut.aire > bas.aire) {
        var pente = (haut.prix - bas.prix) / (haut.aire - bas.aire);
        r = { pente: pente, fixe: bas.prix - pente * bas.aire };
      }
    }
    REGLE_VENTE[id] = r;
    return r;
  }

  /* Le PRIX DE VENTE d UN panneau de ce support a ce format, monte et pret a
     poser. null s il ne rentre pas dans une feuille de 4 x 8, ou si la
     grandeur n est pas une grandeur standard : la question du prix ne se pose
     meme pas, on ne le fabrique pas. */
  function prixSupport(s, c) {
    if (!s || s.id === 'aucun' || !c) return 0;
    if (!supportOffert(s, c)) return null;
    var r = regleVente(s.id);
    if (!r) return null;
    return r.fixe + r.pente * c.aire;
  }

  function detailSupport(s, c) {
    return { parFeuille: parFeuille(c.l, c.h), prix: prixSupport(s, c) };
  }

  /* ------------------------------------------------- la table des matieres */

  function memoriser() {
    if (ORIG) return;
    var d = D();
    if (!d || !d.MATIERES) return;
    ORIG = {};
    d.MATIERES.forEach(function (m) {
      ORIG[m.id] = { parPo2: m.parPo2, pct: m.pct, min: m.min };
    });
  }

  function restaurer() {
    var d = D();
    if (!ORIG || !d) return;
    d.MATIERES.forEach(function (m) {
      var o = ORIG[m.id];
      if (!o) return;
      if (o.parPo2 === undefined) delete m.parPo2; else m.parPo2 = o.parPo2;
      if (o.pct === undefined) delete m.pct; else m.pct = o.pct;
      m.min = o.min;
    });
  }

  function courante() {
    var d = D(), e = S() && S().etat;
    if (!d || !e) return null;
    for (var i = 0; i < d.MATIERES.length; i++) if (d.MATIERES[i].id === e.matiere) return d.MATIERES[i];
    return null;
  }

  /* Le prix de base de scdm.js, pour une surface et une quantite donnees.
     prixBase(cote, q) = prixPourAire(cote x cote, q) : on lui passe la racine. */
  function base(aire, q) {
    return S().prixBase(Math.sqrt(aire), q);
  }

  /* Le supplement PROPRE de la matiere, calcule sur la copie intacte. */
  function supMatiere(m, b, q, aire) {
    var o = ORIG && ORIG[m.id];
    if (!o) return 0;
    if (o.parPo2) return Math.max(o.parPo2 * aire * q, o.min || 0);
    if (o.pct) return Math.max(b * o.pct, o.min || 0);
    return 0;
  }

  function supFinition(b) {
    var d = D(), e = S().etat;
    for (var i = 0; i < d.FINITIONS.length; i++) {
      var f = d.FINITIONS[i];
      if (f.id === e.finition) return f.pct ? Math.max(b * f.pct, f.min || 0) : 0;
    }
    return 0;
  }

  function supForme() {
    var d = D(), e = S().etat;
    for (var i = 0; i < d.FORMES.length; i++) if (d.FORMES[i].id === e.forme) return d.FORMES[i].sup || 0;
    return 0;
  }

  /* ------------------------------------------------------------- LE CALCUL */

  /* On remet la table intacte, puis on ecrit dans la matiere choisie tout ce
     qu il faut : son propre supplement, le support, et — sur un panneau
     routier — de quoi annuler la degressivite de la grille. */
  /* Pancarte ou autocollant ? DEUX signaux, et il suffit d un seul :
     - un support rigide est choisi (c est un panneau, point) ;
     - c est un panneau routier.

     LE SIGNAL DE SURFACE A ETE RETIRE LE 6 SEPTEMBRE 2026. Il disait : au-dela
     de 144 po2, c est une pancarte. Il creait une falaise de prix. Un 11 x 11
     po (aire 121) restait sur la grille des autocollants et coutait 45 $ ; un
     12 x 12 po (aire 144) basculait sur la grille des pancartes et tombait a
     30 $. Une piece PLUS GRANDE coutait 33 % MOINS CHER, et l inversion tenait
     jusqu a dix exemplaires.

     Pourquoi aucun seuil ne pouvait la reparer : les deux grilles ne se
     croisent nulle part. Celle des pancartes est moins chere a l unite et plus
     chere en gros volume — a n importe quelle taille. Deplacer le seuil ne
     fait que deplacer la marche.

     La vraie regle est celle-ci : le prix de base des pancartes (MEC de mise
     en route + le taux d impression) est le socle d une piece qui va AUSSI
     porter le cout d un support. Applique a un vinyle nu, il vend un
     autocollant de douze pouces moins cher qu un de dix. Un vinyle sans
     support reste donc sur la grille des autocollants, quelle que soit sa
     taille. Depuis que la degressivite a ete refaite le 11 septembre 2026,
     l ecart est encore plus grand au volume : raison de plus pour que les
     deux grilles ne se melangent pas. */
  function estPancarte(c, s) {
    if (s && s.id !== 'aucun') return true;
    return !!estRoutier();
  }

  function appliquer() {
    memoriser();
    memoriserGrille();
    restaurer();

    var c = cotes();
    if (!c || !S().prixBase) return null;

    var s = support();
    var cs = prixSupport(s, c);
    if (cs === null) {
      /* Pas offert a cette grandeur. On ne touche PAS a « choix » : le souhait
         du client survit, et le support se rallume tout seul des qu il revient
         a une grandeur standard. */
      cs = 0;
    }
    effectif = s;

    /* LA GRILLE SE POSE ICI, avant tout calcul. On est en capture, donc avant
       scdm.js : quand il calcule, il lit deja la bonne. */
    var pancarte = estPancarte(c, s);
    poserGrille(pancarte ? 'pancarte' : 'collant');

    var routier = estRoutier();
    if (!routier && s.id === 'aucun') {
      /* On ne prend PAS la main : le supplement de matiere reste celui de la
         table, et scdm.js peut donc lui appliquer son plafond. */
      window.SCDM_PANNEAU_ACTIF = false;
      return { possible: true, support: s, cout: 0, cotes: c, pancarte: pancarte };
    }

    var m = courante();
    if (!m) return null;

    var q = qte(), aire = c.aire, voulu;

    if (routier) {
      /* Le prix d UN panneau multiplie par la quantite, MOINS la mise en
         route des panneaux suivants : on ne la fait qu une fois. C est tout
         le rabais de quantite, et il ne touche ni la matiere ni le faconnage.
         voulu ne peut pas devenir negatif : apres avoir retire MEC x (q - 1),
         il reste MEC x 1, exactement ce que bq contient, et le taux unitaire
         de taux(1) est toujours superieur ou egal au taux degressif de bq. */
      var b1 = base(aire, 1);
      var unite = b1 + supMatiere(m, b1, 1, aire) + supFinition(b1) + supForme() + cs;
      var bq = base(aire, q);
      voulu = unite * q - MEC * (q - 1) - bq - supFinition(bq) - supForme();
    } else {
      var b = base(aire, q);
      voulu = supMatiere(m, b, q, aire) + cs * q;
    }

    if (!(voulu > 0)) voulu = 0;
    m.parPo2 = voulu / (aire * q);
    m.pct = 0;
    m.min = 0;

    /* ON PREND LA MAIN. Tout le prix du panneau — matiere, support, montage —
       vient d etre ecrit dans m.parPo2. Ce n est plus un supplement au sens
       ordinaire, c est le produit lui-meme. scdm.js doit le savoir, sinon son
       plafond des supplements vendrait l alupanel a moitie prix. */
    window.SCDM_PANNEAU_ACTIF = true;
    return { possible: true, support: s, cout: cs, cotes: c, routier: routier,
             pancarte: pancarte };
  }

  /* scdm.js ne publie pas sa fonction de rendu. Un evenement « input » sur le
     champ de largeur passe par SON ecouteur, qui relit la meme valeur et
     redessine tout : aucun effet de bord, et le prix suit. */
  function rafraichir() {
    var el = document.getElementById('scdmLargeur');
    if (el) el.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* --------------------------------------------------------------- LE RENDU */

  function poser() {
    if (champ && document.body.contains(champ)) return true;
    var rangee = document.getElementById('scdmMatieres');
    if (!rangee) return false;
    var enrobage = rangee.parentNode;                 /* .rail-wrap */
    var fldMat = enrobage && enrobage.parentNode;     /* .fld.plein */
    if (!fldMat || !fldMat.parentNode) return false;

    /* L encadre de la signalisation, AU-DESSUS des matieres. */
    boite = document.createElement('div');
    boite.className = 'scdm-panneau';
    boite.id = 'scdmPanneau';
    boite.hidden = true;
    boite.setAttribute('role', 'status');
    fldMat.insertBefore(boite, enrobage);

    /* LA RANGEE DES SUPPORTS EST LA DERNIERE DU CONFIGURATEUR (9 septembre
       2026). Elle etait juste sous les matieres ; elle passe tout en bas,
       apres le laminage, JUSTE AVANT le bloc du bouton « Ajouter a ma
       commande ».

       POURQUOI. Le support est la seule decision qui DEPEND de toutes les
       autres : il n est offert qu a une grandeur standard (donc apres le
       format), la surface effacable a sec ne se pose que sur du rigide (donc
       apres le laminage), et son prix se calcule sur la grandeur ET la
       quantite. Le demander en premier obligeait le client a revenir sur ses
       pas des qu il changeait un format.

       COMMENT. On vise le bloc du bouton (.panneau-ajout) dans le meme
       formulaire et on s insere avant lui. Si ce bloc manquait — un gabarit
       remanie —, on retombe sur l ancien emplacement plutot que de ne rien
       afficher : mieux vaut une rangee mal placee qu un support invendable. */
    champ = document.createElement('div');
    champ.className = fldMat.className;
    champ.id = 'scdmSupportFld';
    champ.innerHTML = '<label>' + texteSupport('field_label', 'Support rigide (optionnel)') + '</label>' +
      '<div class="opts" id="scdmSupports"></div>' +
      '<div class="scdm-fmt" id="scdmFormats" hidden></div>' +
      '<p class="scdm-sup-note" id="scdmSupportNote"></p>';
    var formulaire = fldMat.parentNode;
    var bloc = formulaire.querySelector('.panneau-ajout');
    if (bloc && bloc.parentNode === formulaire) formulaire.insertBefore(champ, bloc);
    else formulaire.insertBefore(champ, fldMat.nextSibling);
    note = document.getElementById('scdmSupportNote');

    /* La phrase sous la rangee des quantites. Elle se pose HORS de #scdmQtes,
       que scdm.js reconstruit a chaque redessin — dedans, elle disparaitrait a
       la premiere frappe du client. */
    var qtes = document.getElementById('scdmQtes');
    if (qtes && qtes.parentNode && !document.getElementById('scdmQteMot')) {
      var mot = document.createElement('p');
      mot.id = 'scdmQteMot';
      mot.className = 'scdm-qte-mot';
      mot.hidden = true;
      qtes.parentNode.insertBefore(mot, qtes.nextSibling);
    }

    document.getElementById('scdmSupports').addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-support]') : null;
      if (!b || b.getAttribute('aria-disabled') === 'true') return;
      /* Une pastille ternie reste CLIQUABLE : c est comme ca que le client
         decouvre les grandeurs standards. Le clic enregistre son souhait, la
         rangee des grandeurs apparait, et le support s allume des qu il en
         choisit une. Seul « Trop grand » est vraiment bloque. */
      choix = b.getAttribute('data-support');
      appliquer();
      peindre();
      rafraichir();
    });

    document.getElementById('scdmFormats').addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-l]') : null;
      if (!b) return;
      poserFormat({ l: Number(b.getAttribute('data-l')), h: Number(b.getAttribute('data-h')) });
      setTimeout(function () { appliquer(); peindre(); }, 30);
    });
    return true;
  }

  function peindreRangee(info) {
    var r = document.getElementById('scdmSupports');
    if (!r) return;
    var c = info && info.cotes;
    var actif = (info && info.support) ? info.support.id : choix;
    var html = SUPPORTS.map(function (s) {
      var cs = c ? prixSupport(s, c) : 0;
      var ok = cs !== null;
      /* Trois etats, et il faut les distinguer : le support est offert ; il ne
         rentre pas dans une feuille de 4 x 8 (rien a faire) ; ou la grandeur
         n est pas standard (un clic sur la grandeur et c est regle). */
      var trop = !ok && c && (parFeuille(c.l, c.h) < 1 || Math.min(c.l, c.h) > IMPRIMABLE);
      var bas = s.id === 'aucun' ? texteSupport('included', 'Inclus')
              : (ok ? texteSupport('unit_extra', '+' + nb(cs) + ' $ ch.', { amount: nb(cs) })
                    : (trop ? texteSupport('too_large', 'Trop grand') : ((document.getElementById('scdmRegles2026') || {}).dataset || {}).button || texteSupport('standard_size', 'Grandeur standard')));
      return '<button type="button" class="opt' + (s.id === actif ? ' on' : '') +
        (ok || trop ? '' : ' hors') + '"' +
        (trop ? ' aria-disabled="true"' : '') +
        ' data-support="' + s.id + '">' + texteSupport('label_' + s.id, s.label) +
        '<small>' + bas + '</small></button>';
    }).join('');
    if (r.innerHTML !== html) r.innerHTML = html;
  }

  /* La rangee des grandeurs standards. Elle n apparait que si le client a
     demande un support : ailleurs, elle n aurait rien a dire. */
  function peindreFormats(info) {
    if (window.SCDM_SUPPORT_DEMANDE().surMesure) {
      var formats = document.getElementById('scdmFormats');
      if (formats) formats.innerHTML = '';
      return;
    }
    var r = document.getElementById('scdmFormats');
    if (!r) return;
    var c = info && info.cotes;
    var s = support();
    var h = '';

    if (c && s.id !== 'aucun' && !dimensionImposee() && parFeuille(c.l, c.h) >= 1) {
      var liste = formatsPour(s, c);
      var ici = estStandard(s, c);
      if (!liste.length) {
        h = '<p class="vide">Aucun panneau standard n’a la proportion de votre ' +
            'visuel (<b>' + nb(c.l, 1) + ' × ' + nb(c.h, 1) + ' po</b> — ' +
            enMm(c.l, c.h) + '). Le support ' +
            'rigide se vend en grandeurs standards : essayez un visuel carré, ' +
            '3 × 4 ou 2 × 3, ou <a href="/pages/soumission">demandez une ' +
            'soumission</a> pour une pièce sur mesure.</p>';
        h = texteSupport('no_ratio_html', h, { width: nb(c.l, 1), height: nb(c.h, 1), mm: enMm(c.l, c.h),
          quote_url: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'pages/soumission' });
      } else {
        /* LE TITRE DIT LA PROPORTION. Quand le client arrive d un modele du
           catalogue, la rangee ne montre QUE les grandeurs qui ont la
           proportion de son dessin : autant lui dire laquelle, sinon la
           liste a l air arbitraire. */
        h = '<span class="t">' +
            (ici ? texteSupport('size_heading', 'Grandeur du panneau — ' + liste.length + ' grandeurs à la ' +
                   'proportion de votre visuel (' + proportion(c) + ')', { count: liste.length, ratio: proportionSupport(c) })
                 : texteSupport('choose_size_html', 'Choisissez une <b>grandeur standard</b> — le panneau rigide ne se ' +
                   'coupe pas sur mesure. Ces ' + liste.length + ' grandeurs ont la ' +
                   'proportion de votre visuel (' + proportion(c) + ') : le dessin ' +
                   'n’est ni étiré ni rogné.', { count: liste.length, ratio: proportionSupport(c) })) +
            '</span><div class="g">' +
            liste.map(function (f) {
              var on = ici && Math.abs(f.l - ici.l) < 0.01 && Math.abs(f.h - ici.h) < 0.01;
              return '<button type="button" class="' + (on ? 'on' : '') + '" data-l="' +
                f.l + '" data-h="' + f.h + '">' + enPo(f.l, f.h).replace(/ po$/, ' ' + texteSupport('inch', 'po')) +
                '<small>' + enMm(f.l, f.h) + '</small></button>';
            }).join('') + '</div>';
      }
    }
    if (r.innerHTML !== h) r.innerHTML = h;
    r.hidden = !h;
  }

  function peindreNote(info) {
    if (!note) return;
    var s = (info && info.support) || support(), c = info && info.cotes;
    var h;
    if (window.SCDM_SUPPORT_DEMANDE().surMesure) {
      var regles = document.getElementById('scdmRegles2026');
      note.textContent = regles ? regles.getAttribute('data-surmesure') : '';
      return;
    }
    if (s.id === 'aucun') {
      h = 'Vous recevez l’autocollant seul, prêt à poser sur votre propre surface. ' +
          'Choisissez un support si vous voulez recevoir la pièce <b>déjà montée et prête à visser</b>.';
      h = texteSupport('no_support_html', h);
    } else if (c) {
      if (document.getElementById('scdmInterneRacine')) {
        note.textContent = texteSupport('description_' + s.id, s.texte) + ' — ' + nb(c.l, 1) + ' × ' + nb(c.h, 1) + ' po (' + enMm(c.l, c.h) + ').';
        return;
      }
      var d = detailSupport(s, c);
      h = s.texte + ' Coupé à <b>' + nb(c.l, 1) + ' × ' + nb(c.h, 1) + ' po</b> (' +
          enMm(c.l, c.h) + ')' +
          (dimensionImposee() ? ', à la dimension exigée par la norme' :
                                ', une de nos grandeurs standards') +
          ', découpé, monté et livré prêt à poser — <b>' + nb(d.prix) + ' $ de plus ' +
          'par pièce</b> à ce format.';
      h = texteSupport('support_note_html', h, { description: texteSupport('description_' + s.id, s.texte),
        width: nb(c.l, 1), height: nb(c.h, 1), mm: enMm(c.l, c.h), price: nb(d.prix),
        size_kind: dimensionImposee() ? texteSupport('required_size', 'à la dimension exigée par la norme') : texteSupport('our_standard', 'une de nos grandeurs standards') });
    } else { h = ''; }
    if (note.innerHTML !== h) note.innerHTML = h;
  }

  function peindreBoite(info) {
    if (!boite) return;
    var h = '';
    if (info && info.routier) {
      var e = S() && S().etat;
      var vernis = e && (e.finition === 'lustre' || e.finition === 'mat');
      h = '<span class="pn-t">' + texteSupport('road_signs', 'Signalisation routière') + '</span>' +
        /* CETTE PHRASE A ETE CORRIGEE LE 11 SEPTEMBRE 2026. Elle disait « Le
           prix ne baisse pas avec la quantite : dix panneaux coutent dix fois
           un panneau ». Ce n etait deja plus vrai depuis le 6 septembre — la
           mise en route se partage — et le passage de la mise en route a 25 $
           l a rendue franchement fausse : un 600 mm perd 15 % a cinq
           exemplaires et 18 % a vingt-cinq. Une phrase que le client peut
           verifier lui-meme en changeant la quantite a l ecran ne doit pas le
           contredire. Elle dit maintenant la meme chose que #scdmQteMot, plus
           bas, et les deux doivent rester d accord. */
        texteSupport('road_quantity_html', '<p><b>Le rabais de quantité reste limité.</b> Seule la mise en route ' +
        'se partage entre les panneaux d’une même commande. La matière et le ' +
        'façonnage, eux, ne baissent pas : chaque panneau se coupe, se perce et ' +
        'se monte un par un.</p>') +
        (vernis ? '' :
          texteSupport('road_varnish_html', '<p><b>Prenez le vernis lustré.</b> Un panneau de route passe ses journées ' +
          'au soleil, au sel et au lavage : le vernis est la couche qui prend l’usure ' +
          'à la place de votre impression. Sans lui, les couleurs pâlissent des années ' +
          'plus tôt. C’est quelques dollars sur une pièce qui doit tenir dix ans.</p>')) +
        texteSupport('lead_time_html', '<p class="pn-d">Délai de fabrication : <b>' + DELAI + '</b>, à partir de ' +
        'l’approbation de votre épreuve.</p>', { delay: texteSupport('lead_time', DELAI) });
    }
    var mot = document.getElementById('scdmQteMot');
    if (mot) {
      mot.hidden = !(info && info.routier);
      mot.textContent = texteSupport('quantity_note', 'Sur la signalisation routière, le rabais de quantité ne porte ' +
        'que sur la mise en route, partagée entre tous les panneaux d’une même commande. ' +
        'La matière et le façonnage, eux, ne baissent pas : chaque panneau se coupe, se ' +
        'perce et se monte un par un. Le prix affiché tient déjà compte de votre quantité.');
    }
    if (h !== dernierRendu) {
      dernierRendu = h;
      boite.innerHTML = h;
      boite.hidden = !h;
    }
    document.body.classList.toggle('scdm-routier', !!(info && info.routier));
  }

  function peindre() {
    if (!champ && !poser()) return;
    var info = appliquer();
    peindreRangee(info);
    peindreFormats(info);
    peindreNote(info);
    peindreBoite(info);
  }

  /* --------------------------------------------------------- sur la commande */

  function accrocher() {
    var b = document.getElementById('scdmAjouter');
    if (!b) return;
    var avant = 0, sAvant = null, cAvant = null, rAvant = false;

    /* EN CAPTURE, donc avant scdm.js : le tarif doit etre juste au moment ou
       il calcule, et une fois le design ajoute il vide le fichier televerse —
       on ne saurait plus dire si c etait un panneau routier. */
    b.addEventListener('click', function () {
      appliquer();
      avant = ((S() && S().commande) || []).length;
      /* Le support EFFECTIF, pas le souhait : si la grandeur n est pas standard,
         le client recoit l autocollant seul, et la commande doit le dire. */
      sAvant = effectif || support();
      cAvant = cotes();
      rAvant = estRoutier();
    }, true);

    b.addEventListener('click', function () {
      var liste = (S() && S().commande) || [];
      if (liste.length <= avant) return;
      var d = liste[liste.length - 1];
      d.props = d.props || {};

      if (sAvant && sAvant.id !== 'aucun' && cAvant) {
        d.props['Support'] = sAvant.label + ' — coupé à ' + nb(cAvant.l, 1) + ' × ' +
          nb(cAvant.h, 1) + ' po' + (sAvant.id === 'alupanel' ? ', ébréché et percé' : '') +
          ', autocollant posé';
      }
      if (rAvant) d.props['Délai'] = DELAI;

      /* Le design suivant repart sans support : c est un choix, pas un reglage
         qui colle a la session. */
      choix = 'aucun';
      setTimeout(function () { peindre(); rafraichir(); }, 60);
    }, false);
  }

  /* ------------------------------------------------------------- demarrage */

  function demarrer() {
    if (!document.getElementById('scdmConfig')) return;
    style();
    memoriser();
    if (!poser()) return;
    accrocher();

    /* En capture : on passe AVANT les ecouteurs de scdm.js, donc le tarif est
       deja juste quand il recalcule. */
    ['input', 'change', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        appliquer();
        /* Le redessin attend la fin du clic : reconstruire la rangee des
           supports pendant qu on clique dessus detacherait le bouton clique. */
        setTimeout(peindre, 0);
      }, true);
    });

    /* Le format et le modele changent aussi tout seuls : on relit. */
    setInterval(peindre, 400);
    peindre();
  }

  function quandPret(n) {
    if (document.getElementById('scdmMatieres') && window.SCDM && window.SCDM.prixBase && window.SCDM_DATA) {
      return demarrer();
    }
    if ((n || 0) > 100) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
